export const JobpostingIcon = ({
  primaryColor = "#ffd800",
  primaryFontColor = "#3b4046",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="82.081"
      height="82.115"
      viewBox="0 0 82.081 82.115"
    >
      <g
        id="Group_44610"
        data-name="Group 44610"
        transform="translate(-660.74 -144.814)"
      >
        <path
          id="Path_6202"
          data-name="Path 6202"
          d="M3172.879,736.479a82.054,82.054,0,0,0,0-32.7,27.219,27.219,0,0,0-22.5-22.947,82.045,82.045,0,0,0-33.757,0,27.221,27.221,0,0,0-22.412,22.375,82.042,82.042,0,0,0,0,33.847,27.222,27.222,0,0,0,22.22,22.343,82.048,82.048,0,0,0,34.142,0A27.22,27.22,0,0,0,3172.879,736.479Z"
          transform="translate(-2431.704 -534.26)"
          fill={primaryColor}
        />
        <g id="suitcase" transform="translate(684.593 171.549)">
          <path
            id="Path_6288"
            data-name="Path 6288"
            d="M18.027,8.446a1.433,1.433,0,0,1-1.432-1.432V4.865h-5.73V7.013A1.432,1.432,0,1,1,8,7.013V4.865A2.868,2.868,0,0,1,10.865,2h5.73a2.868,2.868,0,0,1,2.865,2.865V7.013A1.433,1.433,0,0,1,18.027,8.446Z"
            transform="translate(3.458 -2)"
            fill={primaryFontColor}
          />
          <path
            id="Path_6289"
            data-name="Path 6289"
            d="M18.206,17.006a2.95,2.95,0,0,1-1.017.172,3.139,3.139,0,0,1-1.1-.2L0,11.62V22.549a3.937,3.937,0,0,0,3.939,3.939h26.5a3.937,3.937,0,0,0,3.939-3.939V11.62Z"
            transform="translate(-0.001 2.16)"
            fill={primaryFontColor}
          />
          <path
            id="Path_6290"
            data-name="Path 6290"
            d="M34.377,8.939v3.28L17.533,17.834a1.06,1.06,0,0,1-.688,0L0,12.219V8.939A3.937,3.937,0,0,1,3.939,5h26.5A3.937,3.937,0,0,1,34.377,8.939Z"
            transform="translate(-0.001 -0.703)"
            fill={primaryFontColor}
          />
        </g>
      </g>
    </svg>
  );
};
